import axiosConfig from '@ictlife/core/config/axios';

export default axiosConfig;
